// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getText } from 'conversations-message-history/email-capture-prompt/operators/emailCapturePromptMessageGetters';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SlottedMessage from '../slotted-message/SlottedMessage';
import AutomatedMessageAvatar from '../avatar/AutomatedMessageAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailCapturePromptMessage = ({
  message,
  positionDescriptors
}) => {
  const timestamp = getTimestamp(message);
  return /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        positionDescriptors,
        use: AGENT
      }
    },
    avatar: {
      Component: AutomatedMessageAvatar
    },
    title: {
      Component: FormattedMessage,
      componentProps: {
        message: 'conversations-inbox-message-history.responder.automatic'
      }
    },
    timestamp: {
      componentProps: {
        timestamp
      }
    },
    body: {
      componentProps: {
        contentText: getText(message)
      }
    }
  });
};
EmailCapturePromptMessage.displayName = 'EmailCapturePromptMessage';
EmailCapturePromptMessage.propTypes = {
  message: RecordPropType('EmailCapturePromptMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default EmailCapturePromptMessage;